$(function () {
    var x, i, j, selElmnt, a, b, c, s;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName("retailListing--dropdown");
    for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 0; j < selElmnt.length; j++) {
            /*for each option in the original select element,
            create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.setAttribute("data-dropdown-index", j);
            s = document.createElement("SPAN");
            s.setAttribute("class", "ddl-circle");
            c.setAttribute("data-dropdown-value", selElmnt.options[j].innerHTML);
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.appendChild(s);
            c.addEventListener("click", function (e) {

                /*when an item is clicked, update the original select box,
                and the selected item:*/
                var y, k, h;
                let s = this.parentNode.parentNode.getElementsByTagName("select")[0];
				h = this.parentNode.previousSibling;
				let selectedValue = this.getAttribute("data-dropdown-value");
				for (let i = 0; i < s.length; i++) {
					let thisFilterName = s.options[i].innerHTML;
					if ((i == 0 && selectedValue == "Clear filters") || thisFilterName == selectedValue) {
						s.selectedIndex = i;
						h.innerHTML = thisFilterName;
						y = this.parentNode.getElementsByClassName("same-as-selected");
						for (k = 0; k < y.length; k++) {
							y[k].removeAttribute("class");
						}
						this.setAttribute("class", "same-as-selected");
						break;
					}
				}
				h.click();
			});
            b.appendChild(c);
        }

        selElmnt.addEventListener("change", function (e) {
            const dropdownItems = this.parentNode.querySelectorAll('[data-dropdown-value]');
            for (let i = 0; i < dropdownItems.length; i++) {
	            const dropdownItem = dropdownItems[i];
                dropdownItem.classList.toggle('same-as-selected', dropdownItem.dataset.dropdownValue == e.target.value);
            }
            this.parentNode.querySelector('.select-selected').innerHTML = e.target.value ? e.target.value : 'Filters';
        });

        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
            /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");

            $(this).siblings('select').trigger("change");
        });
    }
    function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x, y, i, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }
    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
});